export const DEFAULT_QUERY_OPTIONS = {
	staleTime: 0,
	retry: false,
	refetchOnWindowFocus: false
};
